module.exports = __webpack_public_path__ + "img/med-ins-reminder.aab4b7da.svg";